export const primaryColors = [
    { className: 'colorA' },
    { className: 'colorB' },
    { className: 'colorC' },
    { className: 'colorX' },
    { className: 'colorY' },
    { className: 'colorZ' }
]

export const backgroundColors = [
    { className: 'bg-1' },
    { className: 'bg-2' }
]